"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamePlatform = exports.GameView = void 0;
// Enums for View and Platform
var GameView;
(function (GameView) {
    GameView["FirstPerson"] = "First Person";
    GameView["ThirdPerson"] = "Third Person";
    GameView["TopDown"] = "Top Down";
    GameView["SideScroller"] = "Side Scroller";
    GameView["Isometric"] = "Isometric";
    GameView["TwoD"] = "2D";
    GameView["ThreeD"] = "3D";
})(GameView || (exports.GameView = GameView = {}));
var GamePlatform;
(function (GamePlatform) {
    GamePlatform["PC"] = "PC";
    GamePlatform["PlayStation"] = "PlayStation";
    GamePlatform["Xbox"] = "Xbox";
    GamePlatform["NintendoSwitch"] = "Nintendo Switch";
    GamePlatform["Mobile"] = "Mobile";
    GamePlatform["Web"] = "Web";
    GamePlatform["VR"] = "VR";
    GamePlatform["AR"] = "AR";
    GamePlatform["Miltiplatform"] = "Multiplatform";
})(GamePlatform || (exports.GamePlatform = GamePlatform = {}));
